import React, { useEffect, useState } from "react";
import ContentLayout from "../../../../../partials/content/ContentLayout";
import * as yup from "yup";
import QuotationHeader from "./quotationHeader";
import { Accordion, AccordionTab } from "primereact/accordion";
import Swal from "sweetalert2";
import {
  getCustomerAddress,
  getCustomerContact,
} from "../../../../../services/sales/customerService";
import {
  getQuotation,
  saveQuotation,
} from "../../../../../services/sales/quotationService";
import { getPredefinedTOCs } from "../../../../../services/commons";
import SalesItem from "../../sales-item/salesItem";
import { PageSubHeader } from "../../../../../../provider/PageDataProvider";
import AppForm from "../../../../../partials/content/Forms/AppForm";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import { sendApprovalRequests, setObject } from "../../../../../utils/utils";
import store from "../../../../../store/store";
import { DateTime } from "luxon";
const quotationSchema = yup.object().shape({
  ID: yup.number(),
  customerType: yup.number(),
  customerRfqNo: yup
    .string()
    .max(255, "Customer RFQ Number maximum characters is 255"),
  quotationDate: yup
    .date()
    .required("Quotation Date is required")
    .max(
      yup.ref("expiryDate"),
      "Quotation Date must be less equal to Expiry Date"
    ),
  expiryDate: yup
    .date()
    .required("Expiry Date is required")
    .min(
      yup.ref("quotationDate"),
      "Expiry Date must be greater equal to Quotation Date"
    ),
  leadID: yup.number(),
  leadName: yup.string().when("customerType", {
    is: 1,
    then: yup.string().required("Lead Name is required"),
  }),
  customerID: yup.number(),
  customerName: yup.string().when("customerType", {
    is: 2,
    then: yup.string().required("Customer Name is required"),
  }),
  salesID: yup.number(),
  salesName: yup.string(),
  currencyID: yup.number(),
  currencyCode: yup.string().required("Currency is required"),
  subTotal: yup.number().required("Please add item to add amount"),
  grandTotal: yup.number().required("Please add item to add amount"),
  note: yup.string(),
  toc: yup.string(),
  address: yup
    .string()
    .required("Address is required")
    .max(255, "Address maximum characters is 255"),
  city: yup
    .string()
    .required("City is required")
    .max(50, "City maximum characters is 50"),
  addressPhone: yup
    .string()
    .matches(
      /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/,
      "Phone Number must be valid. e.g. +6281XXXXXXX or 081XXXXXXX"
    )
    .max(50, "Phone Number maximum characters is 50"),
  addressEmail: yup
    .string()
    .email("Email must be valid. e.g. joe@invifo.com")
    .max(50, "Email maximum characters is 50"),
  province: yup.string().max(50, "Province maximum characters is 50"),
  countryCode: yup.string(),
  postalCode: yup.string().max(10, "Postal Code maximum characters is 10"),
  contactName: yup
    .string()
    .required("Contact Name is required")
    .max(255, "Contact Name maximum characters is 255"),
  position: yup.string().max(50, "Position maximum characters is 50"),
  contactPhone: yup
    .string()
    .required("Phone Number is required")
    .matches(
      /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/,
      "Phone Number must be valid. e.g. +6281XXXXXXX or 081XXXXXXX"
    )
    .max(50, "Phone Number maximum characters is 50"),
  contactEmail: yup
    .string()
    .email("Email must be valid. e.g. joe@invifo.com")
    .max(50, "Email maximum characters is 50"),
  cashAccountName: yup.string().when("dpAmount", {
    is: (val) => val > 0,
    then: yup.string().required("Cash Account is required"),
  }),
  quotationItem: yup
    .array()
    .of(
      yup.object().shape({
        ID: yup.number(),
        childItem: yup.bool(),
        itemID: yup.number().required(),
        varCode: yup.string(),
        itemName: yup.string().required("Item is required"),
        qty: yup
          .number()
          .transform((value) => (isNaN(value) ? 0 : value))
          .nullable()
          .required("Quantity is required")
          .moreThan(0, "Quantity cannot be zero or empty")
          .default(0),
        uomID: yup.number().default(0),
        uomName: yup.string().when("itemID", {
          is: (val) => val > 0,
          then: yup.string().required("Unit is required"),
        }),
        unitPrice: yup
          .number()
          .transform((value) => (isNaN(value) ? 0 : value))
          .nullable()
          .required("Unit Price is required")
          .when("childItem", {
            is: false,
            then: yup
              .number()
              .moreThan(0, "Unit Price cannot be zero or empty"),
          })
          .default(0),
        discountPercent: yup.number().default(0),
        discountAmount: yup
          .number()
          .transform((value) => (isNaN(value) ? 0 : value))
          .nullable()
          .default(0),
        taxPercent: yup.number().default(0),
        taxAmount: yup
          .number()
          .transform((value) => (isNaN(value) ? 0 : value))
          .nullable()
          .default(0),
        totalPrice: yup
          .number()
          .transform((value) => (isNaN(value) ? 0 : value))
          .nullable()
          .required("Total Price is required")
          .default(0),
        deleteInd: yup.boolean(),
      })
    )
    .required("Quotation Items is required"),
  quotationAddCost: yup.array().of(
    yup.object().shape({
      ID: yup.number(),
      itemName: yup.string().required("Cost Name is Required"),
      costPrice: yup
        .number()
        .transform((value) => (isNaN(value) ? 0 : value))
        .nullable()
        .required("Cost Price is required")
        .moreThan(0, "Cost Price cannot be zero or empty")
        .default(0),
    })
  ),
});

function QuotationForm({
  quotationIDImp = 0,
  ticketID = 0,
  salesCardID = 0,
  lead = { ID: 0, leadName: "", contactName: "" },
  customer = { ID: 0, customerName: "" },
  user = { ID: 0, firstName: "", lastName: "" },
  headSubmitButton = true,
  history,
  match,
  onCloseDialog,
  onConfirmSave,
}) {
  let quotationID = 0;
  if (ticketID === 0 && salesCardID === 0 && quotationIDImp === 0) {
    quotationID = match.params.quotationID;
  } else if (quotationIDImp > 0) {
    quotationID = quotationIDImp;
  }
  const { companyProfile, socket } = useGlobalData();
  const { auth } = store.getState();
  const { fullName } = auth.user;
  let quotationData = {
    ID: 0,
    quotationCode: "",
    ver: 1,
    giStatus: 1,
    invoiceStatus: 1,
    salesStatus: 1,
    salesStatusDesc: "",
    customerRfqNo: "",
    customerType: customer.ID > 0 ? 2 : 1,
    quotationDate: DateTime.now().startOf("day"),
    expiryDate: DateTime.now()
      .endOf("day")
      .plus({ months: 1 }),
    ticketID,
    salesCardID,
    leadID: lead.ID,
    leadName:
      lead.leadName !== "" ? lead.leadName + " - " + lead.contactName : "",
    customerID: customer.ID,
    customerName: customer.customerName,
    salesID: user.ID,
    salesName: user.firstName + " " + user.lastName,
    discountID: 0,
    discountName: "",
    addressName: {},
    address: "",
    city: "",
    province: "",
    countryCode: companyProfile.countryCode,
    postalCode: "",
    addressPhone: "",
    addressEmail: "",
    contact: {},
    contactName: "",
    position: "",
    contactPhone: "",
    contactEmail: "",
    currencyID: companyProfile.currency.ID,
    currencyCode: companyProfile.currency.currencyCode,
    dpInvoice: false,
    cashAccountID: 0,
    cashAccountName: "",
    dpPercent: 0,
    dpAmount: 0,
    invoiceDeadlineDate: DateTime.now()
      .endOf("day")
      .plus({ days: 14 }),
    exchangeRate: 1,
    subTotal: 0,
    discountPercent: 0,
    discountAmount: 0,
    taxName: "",
    taxPercent: 0,
    taxAmount: 0,
    addCostTotal: 0,
    grandTotal: 0,
    localAmount: 0,
    note: "",
    tocName: {},
    toc: "",
    approvalStatus: 0,
    approvalStatusDesc: "",
    quotationItem: [],
    quotationAddCost: [],
    CreatedAt: DateTime.now(),
    UpdatedAt: DateTime.now(),
    createdBy: 0,
    updatedBy: 0,
  };

  useEffect(() => {
    const { auth } = store.getState();

    if (quotationID > 0) {
      setObject(socket, "lock", quotationID, "QUOT", auth.user)
        .then((response) => {
          getQuotationData(quotationID);
        })
        .catch((error) => {
          history.push("/sales/quotation/quotation-list");
        });
    } else if (customer.ID > 0) {
      quotationData.customerID = customer.ID;
      quotationData.customerName = customer.customerName;
      quotationData.address = customer.address;
      quotationData.city = customer.city;
      quotationData.province = customer.province;
      quotationData.countryCode = customer.countryCode;
      quotationData.postalCode = customer.postalCode;
      quotationData.addressPhone = customer.addressPhone;
      quotationData.addressEmail = customer.addressEmail;
      quotationData.contactName = customer.contactEmail;
      quotationData.position = customer.position;
      quotationData.contactPhone = customer.contactPhone;
      quotationData.contactEmail = customer.contactEmail;
      getPredefinedTOCs("QUOT").then((response) => {
        const { data } = response.data;
        data.predefinedTOCs.map((quotationTOC, index) => {
          quotationData.tocName = quotationTOC;
          quotationData.toc = quotationTOC.toc;
        });
        handleChangeCustomer(customer.ID);
        setQuotationData(quotationData);
      });
    } else if (lead.ID > 0) {
      quotationData.leadID = lead.ID;
      quotationData.leadName = lead.leadName;
      quotationData.address = lead.address;
      quotationData.city = lead.city;
      quotationData.province = lead.province;
      quotationData.countryCode = lead.countryCode;
      quotationData.postalCode = lead.postalCode;
      quotationData.addressPhone = lead.addressPhone;
      quotationData.addressEmail = lead.addressEmail;
      quotationData.contactName = lead.contactName;
      quotationData.position = lead.position;
      quotationData.contactPhone = lead.contactPhone;
      quotationData.contactEmail = lead.contactEmail;
      getPredefinedTOCs("QUOT").then((response) => {
        const { data } = response.data;
        data.predefinedTOCs.map((quotationTOC, index) => {
          quotationData.tocName = quotationTOC;
          quotationData.toc = quotationTOC.toc;
        });
        setQuotationData(quotationData);
      });
    }
    getQuotationTOCData("QUOT");
    return () => {
      if (quotationID > 0) {
        setObject(socket, "release", quotationID, "QUOT", auth.user);
      }
    };
  }, [quotationID]);

  const [quotation, setQuotationData] = useState(quotationData);
  const [customerAddresses, setCustomerAddresses] = useState([]);
  const [customerContacts, setCustomerContacts] = useState([]);
  const [quotationTOCs, setQuotationTOCs] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <React.Fragment>
      {ticketID === 0 && salesCardID === 0 && quotationIDImp === 0 ? (
        <PageSubHeader
          title="Quotation Form"
          breadcrumbs={[
            { page: "/menu", title: "Menu", active: false },
            {
              page: "/sales/quotation/quotation-list",
              title: "Quotations",
              active: false,
            },
            {
              page: "/sales/quotation/quotation-form",
              title: "Quotation Form",
              active: true,
            },
          ]}
          actionButtons={[
            {
              title: "",
              color: "label-brand",
              icon: "fas fa-backward",
              onClick: () => {
                history.push("/sales/quotation/quotation-list");
              },
            },
          ]}
        />
      ) : null}
      <AppForm
        initialValues={quotation}
        validationSchema={quotationSchema}
        onSubmit={async (values, { setStatus, setSubmitting }) => {
          const quotationSave = { ...values };
          quotationSave.dpPercent = parseFloat(quotationSave.dpPercent);
          quotationSave.dpAmount = parseFloat(quotationSave.dpAmount);
          quotationSave.subTotal = parseFloat(quotationSave.subTotal);
          quotationSave.grandTotal = parseFloat(quotationSave.grandTotal);
          quotationSave.discountAmount = parseFloat(
            quotationSave.discountAmount
          );
          quotationSave.taxAmount = parseFloat(quotationSave.taxAmount);

          quotationSave.quotationItem.forEach((item) => {
            item.unitPrice = parseFloat(item.unitPrice);
            item.qty = parseFloat(item.qty);
            item.totalPrice = parseFloat(item.totalPrice);
            item.discountAmount = parseFloat(item.discountAmount);
            item.taxAmount = parseFloat(item.taxAmount);
            item.discountPercent = parseFloat(item.discountPercent);
            item.taxPercent = parseFloat(item.taxPercent);
          });
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title: "Are you sure want to save this Quotation ?",
              text: "Please note that you are responsible for this action",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                saveQuotation(quotationSave).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Saved",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });

                  let toUsers = [];
                  const { data } = response.data;

                  if (
                    data.notificationToUsers &&
                    data.notificationToUsers.length > 0
                  ) {
                    data.notificationToUsers.map(
                      (notificationToUser, index) => {
                        toUsers.push({
                          ID: notificationToUser.toUserID,
                        });
                      }
                    );
                  }

                  if (toUsers && toUsers.length > 0) {
                    sendApprovalRequests(socket, fullName, toUsers);
                  }

                  setQuotationData(quotationSave);
                  if (onConfirmSave) {
                    onConfirmSave();
                  } else {
                    history.push("/sales/quotation/quotation-list");
                  }
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        }}
        headSubmitButton={headSubmitButton}
      >
        <ContentLayout>
          <QuotationHeader
            customerAddresses={customerAddresses}
            onChangeCustomer={handleChangeCustomer}
            onSetCustomerAddresses={setCustomerAddresses}
            customerContacts={customerContacts}
            onSetCustomerContacts={setCustomerContacts}
            quotationTOCs={quotationTOCs}
            onSetQuotationTOCs={setQuotationTOCs}
          />
          <div className="accordion">
            <div className="card">
              <Accordion
                className="accordion"
                activeIndex={activeIndex}
                onTabChange={(e) => setActiveIndex(e.index)}
              >
                <AccordionTab
                  header={
                    <React.Fragment>
                      <i className="fas fa-sitemap"></i>
                      <span>
                        <strong>Quotation Items</strong>
                      </span>
                    </React.Fragment>
                  }
                >
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <SalesItem
                        salesCardID={salesCardID}
                        property="quotationItem"
                        propertyAddCost="quotationAddCost"
                        onCloseDialog={onCloseDialog}
                      />
                    </div>
                  </div>
                </AccordionTab>
              </Accordion>
            </div>
          </div>
        </ContentLayout>
      </AppForm>
    </React.Fragment>
  );

  async function getQuotationData(quotationID) {
    if (quotationID > 0) {
      const response = await getQuotation(quotationID);
      const { data } = response.data;
      const { quotation: quotationData } = data;
      let quotation = {
        ID: quotationData.ID,
        quotationCode: quotationData.quotationCode,
        ver: quotationData.ver,
        giStatus: 1,
        invoiceStatus: 1,
        salesStatus: quotationData.salesStatus,
        salesStatusDesc: quotationData.salesStatusDesc,
        customerRfqNo: quotationData.customerRfqNo,
        quotationDate: quotationData.quotationDate,
        expiryDate: quotationData.expiryDate,
        leadID: quotationData.leadID,
        customerID: quotationData.customerID,
        salesID: quotationData.salesID,
        salesName:
          quotationData.sales.firstName + " " + quotationData.sales.lastName,
        discountID: quotationData.discountID,
        discountName: quotationData.discount.discountName,
        customerName:
          quotationData.customerID > 0
            ? quotationData.customer.customerName
            : quotationData.lead.leadName,

        address: quotationData.address,
        city: quotationData.city,
        province: quotationData.province,
        countryCode: quotationData.countryCode,
        postalCode: quotationData.postalCode,
        addressPhone: quotationData.addressPhone,
        addressEmail: quotationData.addressEmail,

        contactName: quotationData.contactName,
        position: quotationData.position,
        contactPhone: quotationData.contactPhone,
        contactEmail: quotationData.contactEmail,

        currencyID: quotationData.currencyID,
        dpInvoice: quotationData.dpPercent > 0 ? true : false,
        cashAccountID: quotationData.cashAccountID,
        cashAccountName: quotationData.cashAccount.accountName,
        dpPercent: quotationData.dpPercent,
        dpAmount: quotationData.dpAmount,
        invoiceDeadlineDate: DateTime.now()
          .endOf("day")
          .plus({ days: 14 }),
        addressID: quotationData.addressID,
        contactID: quotationData.contactID,
        currencyCode: quotationData.currency.currencyCode,
        exchangeRate: quotationData.exchangeRate,
        subTotal: quotationData.subTotal,
        discountPercent: quotationData.discountPercent,
        discountAmount: quotationData.discountAmount,
        taxPercent: quotationData.taxPercent,
        taxAmount: quotationData.taxAmount,
        addCostTotal: quotationData.addCostTotal,
        grandTotal: quotationData.grandTotal,
        note: quotationData.note,
        toc: quotationData.toc,
        approvalStatus: quotationData.approvalStatus,
        approvalStatusDesc: quotationData.approvalStatusDesc,
        quotationItem: [],
        quotationAddCost: quotationData.quotationAddCost,
        CreatedAt: quotationData.CreatedAt,
        UpdatedAt: quotationData.UpdatedAt,
        createdBy: quotationData.createdBy,
        updatedBy: quotationData.updatedBy,
      };

      if (quotationData.leadID > 0 && quotationData.customerID === 0) {
        quotation.customerType = 1;
        quotation.leadName =
          quotationData.lead.leadName + " " + quotationData.lead.contactName;
      } else if (quotationData.customerID > 0) {
        quotation.customerType = 2;
      }

      quotationData.quotationItem.forEach((quotationItem) => {
        quotation.quotationItem.push({
          ID: quotationItem.ID,
          childItem:
            quotationItem.discountFreeItemID > 0 ||
            quotationItem.itemPackageDetailID > 0
              ? true
              : false,
          discountFreeItemID: quotationItem.discountFreeItemID,
          discountAmountOffItemID: quotationItem.discountAmountOffItemID,
          giStatus: quotationItem.giStatus,
          itemID: quotationItem.itemID,
          itemType: quotationItem.itemType,
          itemTypeName: quotationItem.itemTypeName,
          itemCode:
            quotationItem.itemID === 0 && quotationItem.itemPackageID > 0
              ? quotationItem.itemPackage.packageCode
              : quotationItem.itemCode,
          itemName:
            quotationItem.itemID === 0 && quotationItem.itemPackageID > 0
              ? quotationItem.itemPackage.packageName
              : quotationItem.itemName,
          varCode: quotationItem.varCode,
          itemPackageID: quotationItem.itemPackageID,
          itemPackageDetailID: quotationItem.itemPackageDetailID,
          qty: quotationItem.qty,
          oriQty: quotationItem.itemPackageDetail.qty,
          currencyID: quotationItem.item.currencyID,
          oriMinimumPrice: quotationItem.item.minimumPrice,
          minimumPrice: quotationItem.item.minimumPrice * quotationItem.qty,
          uomID: quotationItem.uomID,
          uomName: quotationItem.uomName,
          unitPrice: quotationItem.unitPrice,
          discountAmountType: 1,
          discountPercent: quotationItem.discountPercent,
          discountAmount: quotationItem.discountAmount,
          taxPercent: quotationItem.taxPercent,
          taxAmount: quotationItem.taxAmount,
          taxName: quotationItem.taxName,
          totalPrice: quotationItem.totalPrice,
          editable: false,
          deleteInd: false,
        });
      });
      handleChangeCustomer(quotation.customerID);
      setQuotationData(quotation);
    }
  }

  async function handleChangeCustomer(customerID = 0) {
    if (customerID > 0) {
      const responseAddress = await getCustomerAddress(customerID);
      const { data: dataAddress } = responseAddress.data;
      setCustomerAddresses(dataAddress.addresses);

      const responseContact = await getCustomerContact(customerID);
      const { data: dataContact } = responseContact.data;
      setCustomerContacts(dataContact.contacts);
    }
  }

  async function getQuotationTOCData(appCode) {
    const response = await getPredefinedTOCs(appCode);
    const { data } = response.data;
    setQuotationTOCs(data.predefinedTOCs);
  }
}

export default QuotationForm;
